<template>
    <rkm-data-table
        :fields="fields.datatables.cid"
        :repository="repositories.cid"
        :request-params="getRequestParams()"
        ref="DataTable"
    >
        <template v-slot:cell(codigo)='{ value }'>
            {{ value | formatCid }}
        </template>

        <template v-slot:cell(actions)='{ item }'>
            <rkm-button
                color="primary"
                title="Selecionar CID."
                small
                @click.stop="$emit('select', item)"
            >
                <rkm-icon icon="check" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository } from '@/mixins'

// Filters.
import formatsFilters from '@/filters/formats'

export default {
    computed: {
        fields() {

            return {
                datatables: {
                    cid: [
                        {
                            name: 'codigo',
                            key: 'codigo',
                            label: 'Código',
                            searchable: true,
                            sortable: true,
                            class: 'col-min'
                        },
                        {
                            name: 'nome',
                            key: 'nome',
                            label: 'Nome',
                            searchable: true,
                            sortable: true
                        },
                        {
                            name: 'actions',
                            key: 'actions',
                            label: 'Ações',
                            class: 'col-min text-center'
                        },
                    ]
                }
            }
        }
    },
    created() {

        this.repositories = {
            cid: this.getConectaSusRepository('sigtap.cid')
        }
    },
    filters: {
        ...formatsFilters
    },
    methods: {
        getRequestParams() {

            const params = {}

            if (this.procedimentoId) {

                params.procedimento_id = this.procedimentoId
            }

            if (typeof this.principal === 'boolean') {

                params.principal = this.principal
            }

            return params
        }
    },
    mixins: [repository],
    props: {
        procedimentoId: { type: Number },
        principal: { type: Boolean },
    }
}
</script>